import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoTrash16 } from '@onefootprint/icons';
import { Button, Divider, IconButton, LinkButton } from '@onefootprint/ui';
import type React from 'react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
export type UploadFileProps = {
  accept: string;
  children: React.ReactNode;
  cta: string;
  iconComponent: Icon;
  id: string;
  label: string;
  onChange: (value: string) => void;
  onRemove?: () => void;
};
const UploadFile = t0 => {
  const $ = _c(35);
  const {
    accept,
    children,
    cta,
    iconComponent: IconComponent,
    id,
    label,
    onChange,
    onRemove
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create.form.uploadFile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  const [fileName, setFileName] = useState("");
  const inputRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      inputRef.current?.click();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClick = t2;
  let t3;
  if ($[2] !== onChange) {
    const readFile = async file => {
      const newValue = await file.text();
      onChange(newValue);
      setFileName(file.name);
    };
    t3 = event => {
      if (!event.target.files?.length) {
        return;
      }
      const [file_0] = event.target.files;
      readFile(file_0);
    };
    $[2] = onChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleChange = t3;
  let t4;
  if ($[4] !== onChange) {
    t4 = () => {
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      onChange("");
      setFileName("");
    };
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleRemove = t4;
  let t5;
  if ($[6] !== IconComponent) {
    t5 = <IconComponent />;
    $[6] = IconComponent;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== id || $[9] !== label || $[10] !== t5) {
    t6 = <label htmlFor={id} className="text-label-2 flex items-center">{t5}{label}</label>;
    $[8] = id;
    $[9] = label;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onRemove || $[13] !== t) {
    t7 = onRemove && <LinkButton onClick={onRemove} destructive={true}>{t(_temp)}</LinkButton>;
    $[12] = onRemove;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex mb-3 justify-between">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== cta) {
    t9 = <div><Button fullWidth={true} onClick={handleClick} variant="secondary">{cta}</Button></div>;
    $[18] = cta;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== children || $[21] !== fileName || $[22] !== handleRemove || $[23] !== t) {
    t10 = fileName ? <><div className="my-4"><Divider /></div><div className="flex items-center justify-between gap-2 md:gap-0"><div className="min-w-0"><p className="text-body-2 text-primary fp-text max-md:break-all">{fileName}</p></div><IconButton aria-label={t(_temp2)} onClick={handleRemove} icon={IcoTrash16} /></div></> : <><div className="flex items-center gap-2 mt-4 mb-4"><Divider /><p className="text-body-2 text-quaternary fp-text">{t(_temp3)}</p><Divider /></div>{children}</>;
    $[20] = children;
    $[21] = fileName;
    $[22] = handleRemove;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <div className="bg-secondary p-4 rounded">{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== accept || $[29] !== handleChange) {
    t12 = <input accept={accept} ref={inputRef} type="file" onChange={handleChange} className="hidden" />;
    $[28] = accept;
    $[29] = handleChange;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t8) {
    t13 = <div>{t8}{t11}{t12}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
export default UploadFile;
function _temp($) {
  return $.remove;
}
function _temp2($_0) {
  return $_0.remove;
}
function _temp3($_1) {
  return $_1.or;
}